<template lang="html">

  <section class="home-area">

    <div class="container">
      <h2 class="main-title">Encuestas</h2>
    </div>


    <div class="contenedor-encuestas" v-if="!loading">
      <encuesta :key="key" :data="encuesta" v-for="(encuesta, key) in encuestas" v-if="!!encuestas"></encuesta>
      <p v-if="!!!encuestas ">Aún no hay encuestas asociadas a tu perfil</p>
    </div>

    <div class="view-loading -small" v-if="loading"></div>

    <router-link class="link" :to="$t('enlaces.encuestas')">Ver más</router-link>

  </section>

</template>

<script lang="js">

  import encuesta from '@/components/parts/encuesta-el';


  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'encuestas-home',
    mounted(){
      if(this.encuestas.length == 0){
        this.loading = true;
        this.requestEncuestas().then(r => {
          this.loading = false;
        });
      }
    },
    data(){
      return{
        loading : false
      }
    },
    methods : {
      ...mapActions(['requestEncuestas']),
    },
    components: {
      'encuesta': encuesta
    },
    computed : {
      ...mapGetters({
        encuestas : 'getEncuestas'
      })
    }
  }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/view-parts/home/encuestas.vue